import {
    createStyles,
    FormControl,
    InputLabel,
    makeStyles,
    MenuItem,
    Select,
  } from "@material-ui/core";
  import React from "react";
  import { CustomTheme } from "../../../types/customTheme";

  const useStyles = makeStyles((theme: CustomTheme) =>
    createStyles({
      dialogTextFieldBackground: {
        backgroundColor: theme.palette.background.entity_dialog_textfield_background,
        borderRadius: "10px",
        [`& fieldset`]: {
          borderRadius: "10px",
          border: "none",
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
          border: "none",
        },
        "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
          border: "none",
        },
      },
    }),
  );
  
  export interface Props {
    handleChangeSelector: any;
    label: any;
    selectedValue: any;
    selectorList: any;
    disable: any;
    useDialogTextFieldBackground?: boolean;
  }
  
  /* Select one item uses this component. */
  const Selector: React.FunctionComponent<Props> = ({
    handleChangeSelector,
    label,
    selectedValue,
    selectorList,
    disable,
    useDialogTextFieldBackground = false,
  }) => {
    const classes = useStyles();
  
    /* Providing selected value with selector name. */
    const handleSelectedData = (e: any) => {
      handleChangeSelector(label, e.target.value);
    };
  
    return (
      <>
        <FormControl
          variant="outlined"
          disabled={disable}
          style={{ margin: "1px", width: "100%" }}
        >
          <InputLabel id="selector-label">{label}</InputLabel>
          <Select
            MenuProps={{
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "left",
              },
              transformOrigin: {
                vertical: "top",
                horizontal: "left",
              },
              getContentAnchorEl: null,
            }}
            labelId="selector-label-id"
            id="selector-id"
            value={selectedValue}
            label={label}
            onChange={handleSelectedData}
            className={
              useDialogTextFieldBackground
                ? classes.dialogTextFieldBackground
                : undefined
            }
          >
            {selectorList.map((value: any) => {
              return <MenuItem value={value.id}>{value.label}</MenuItem>;
            })}
          </Select>
        </FormControl>
      </>
    );
  };

  export default Selector;
